import unpaidModalImage from "@/assets/images/activity/2026/618Promotion/unpaid-modal-v2.webp";
import upgradeModalImage from "@/assets/images/activity/2026/618Promotion/upgrade-modal-v2.webp";
import type { UserSegment } from "@/views/power/components/VipPackageActivity/types";

/** 每日弹窗记录键 */
export const PROMOTION_618_RECORD_KEY = "618_promotion_popup";

/** 弹窗画布尺寸（与 Figma 导出一致） */
export const PROMOTION_618_MODAL_WIDTH = 600;
export const PROMOTION_618_MODAL_HEIGHT = 604;

/** 续费弹窗倒计时槽位中心，与 upgrade-modal.png 的预留位置对齐 */
export const PROMOTION_618_ACTIVE_MEMBER_COUNTDOWN_TOP = "47.2%";

/** 未付费与过期用户共用同一弹窗图（PRD：未付费和过期会员弹窗） */
export const PROMOTION_618_MODAL_IMAGES: Partial<Record<UserSegment, string>> = {
  neverPaid: unpaidModalImage,
  expired: unpaidModalImage,
  activeVipSvip: upgradeModalImage
};
